import styled from "@emotion/styled";
import {eerieBlack} from "../../styles/colors";
import arrowLeft from '../../images/arrow-left.svg'

export const BlogHeader = styled.div`
  max-width: 570px;
  text-justify: distribute;
  margin: 0 auto;
`

export const TagContainer = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`

export const PostContent = styled.div`
  max-width: 740px;
  text-justify: distribute;
  margin: 0 auto;

  font-family: 'DM Sans', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 150%;

  color: #1C1C1C;

  p, h3 {
    color: ${eerieBlack['800']};
    margin-bottom: 32px;
    word-break: break-word;
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;

    letter-spacing: -0.35px;
  }

  strong {
    font-weight: 600;
  }

  h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 130%;

    letter-spacing: -0.6px;
  }

  h3 strong {
    font-weight: 700;
  }

  h2 {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 140%;
    margin-bottom: 80px;

    color: ${eerieBlack['800']};
  }

  h3 strong {
    font-weight: 600;
  }

  h4 {
    font-weight: 700;
    font-size: 24px;
    line-height: 140%;
    letter-spacing: -0.5px;

    color: ${eerieBlack['800']};
  }

  a {
    color: #1C1C1C;
    text-decoration: underline;
  }

  figure {
    margin-bottom: 32px;
  }

  img {
    border-radius: 16px;
    background: ${eerieBlack['400']}
  }

  figcaption {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 130%;
    text-align: center;
    margin-top: 8px;

    color: #ADADAD;
  }

  .kg-bookmark-card {
    border: 1px solid #e5eff5;
    background: #fff;
    border-radius: 5px;
  }

  .kg-bookmark-container {
    display: flex;
  }

  a.kg-bookmark-container {
    text-decoration: none;
  }

  .kg-bookmark-card .kg-bookmark-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-basis: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px;
    height: 130px;
  }

  .kg-bookmark-card .kg-bookmark-title {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    text-decoration: none;
    margin-bottom: 10px;
  }

  .kg-bookmark-card .kg-bookmark-description {
    font-size: 14px;
    line-height: 20px;
    text-decoration: none;
    overflow: hidden;
  }

  .kg-bookmark-card .kg-bookmark-thumbnail {
    position: relative;
    flex-grow: 1;
    min-width: 33%;
  }

  .kg-bookmark-card .kg-bookmark-thumbnail img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .kg-bookmark-card .kg-bookmark-metadata {
    display: none;
  }

  .kg-image-card, .kg-gallery-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .kg-image-card, .kg-gallery-image {
    max-width: 100%;
    height: inherit;
    margin: 0;
    margin-bottom: 20px
  }

  .kg-image-card img, .kg-gallery-image img {
    max-width: 100%;
    height: inherit;
  }

  .kg-embed-card iframe{
    width: 100%;
    min-height: 415px;
  }

  figure {
    margin: 0 0;
  }

  .summary h2 {
    margin: 0
  }

  .summary ul li {
    font-family: 'DM Sans', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 140%;

    letter-spacing: -0.45px;
    text-decoration-line: underline;

    list-style-image: url(${arrowLeft});
    padding-inline-start: 8px;
  }

  //This hack tricks the browser anchor link navigator to consider fixed height headers
  [id]::before {
    content: '';
    display: block;
    height: 100px;
    margin-top: -100px;
    visibility: hidden;
  }

  .post_informations {
    margin-bottom: 32px
  }

  .post_informations h5 {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.18px;

    color: ${eerieBlack['800']};
  }

  .post_informations h6 {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.09px;

    color: ${eerieBlack['500']};
  }

  .kg-blockquote-alt {
    font-family: 'DM Sans', serif;
    font-size: 24px;
    line-height: 140%;
    letter-spacing: -0.45px;

    color: ${eerieBlack['600']};

    padding-left: 32px;
    border-left: 2px solid #3C00CF;
    margin: 24px 0 32px
  }
`
